<template>
  <div id="app" v-loading="loading">
    <router-view />
  </div>
</template>

<script>
import store from './store'
import V2NIM, { V2NIMConst } from 'nim-web-sdk-ng'
import { IMUIKit } from '@xkit-yx/im-kit-ui'
import localOptions from '@/config/imLocalOptions'

export default {
  name: 'App',
  data() {
    return {
      loading: false,
      logoutMsg: null,
    }
  },
  async created() {
    // 页面刷新时恢复登录信息
    await store.dispatch('restoreLogin')
  },
  mounted() {
    this.initNIM()
  },
  methods: {
    // 退出提示（防止重复）
    showLogoutMessage(msg) {
      if (this.logoutMsg) return
      this.logoutMsg = this.$message.info(msg)
      setTimeout(() => {
        this.logoutMsg = null
      }, 2000)
    },
    // 初始化 SDK
    initNIM() {
      if (window.$nim) return

      const instanceParam1 = {
        appkey: process.env.VUE_APP_IM_API_KEY,
        enableV2CloudConversation: false,
        debugLevel: 'error', //off error info debug
        apiVersion: 'v2',
      }
      const instanceParam2 = {
        V2NIMLoginServiceConfig: {
          lbsUrls: ['https://lbs.netease.im/lbs/webconf.jsp'],
          linkUrl: 'weblink.netease.im:443',
        },
      }

      try {
        const nim = V2NIM.getInstance(instanceParam1, instanceParam2)
        this.addEvent(nim)
        window.$nim = nim

        // 初始化 UIKit 实例
        window.$uikit = new IMUIKit({
          nim,
          singleton: true,
          localOptions,
        })
        console.log('NIM SDK 初始化完成')
      } catch (err) {
        this.$message.error('NIM SDK 初始化失败')
        console.error('NIM SDK 初始化失败:', err)
      }
    },

    // 注册事件
    addEvent(nim) {
      nim.V2NIMLoginService.on('onLoginStatus', status => {
        console.log('登录状态变化:', status)
        if (status === 2) {
          this.loading = true
        } else if (status === 1) {
          this.loading = false
          this.$message.success('登录成功')
        } else if (status === 0) {
          this.loading = false
          this.showLogoutMessage('您已退出登录,即将跳转到登录页')
          setTimeout(() => {
            this.$router.replace('/login').catch(() => {})
          }, 2000)
        } else {
          this.loading = false
        }
      })

      nim.V2NIMLoginService.on('onLoginFailed', status => {
        console.log('事件 onLoginFailed:', status)
      })

      nim.V2NIMLoginService.on('onDisconnected', status => {
        console.log('事件 onDisconnected:', status)
      })
    },
  },

  beforeDestroy() {
    if (window.$nim) {
      window.$nim.V2NIMLoginService.off('onLoginStatus')
      window.$nim.V2NIMLoginService.off('onLoginFailed')
      window.$nim.V2NIMLoginService.off('onDisconnected')
    }
    this.$store.commit('LOGOUT')
  },
}
</script>

<style></style>
